import { BCMSRecord, useBCMSContext, useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "components/custom-ui/CustomModal";
import Classes, { Transaction, TransferTransaction } from "model";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function ReviewTransferModal
 * @returns {React.Component}
 * @description The Review and Transfer modal that is shown after going through the quick transfer workflow
 * @property {OBJECT} data - The data passed to the modal on open
 */
export default function ReviewTransferModal(props) {
  const context = useBCMSContext();
  // Get the workflow step from the data being passed
  const workflowStep = props.data;
  const { transfer } = workflowStep.getStepState;
  const { close } = useBCMSModal();
  // Set the amount and account names otherwise set to a default string
  const transferAmount = transfer.amount ? transfer.amount.format() : "[$xx.xx]";
  const transferToAccount = transfer.to.nickname ?? "[transferToAccount]";
  const transferFromAccount = transfer.from.nickname ?? "[transferFromAccount]";

  const submit = evt => {
    // Initalzie a new transaction
    const transaction = Transaction.init({ 
      "amount" : transfer.amount, 
      "account" : transfer.from,
      "status" : "succeeded",
      "type" : "regular",
      "description" : "Transfer",
      "id" : Transaction.nextID()
    });
    // Initalize a new transfer
    const transactionTransfer = TransferTransaction.init({ 
      ...transaction.record, 
      ...transfer.record(), 
      "id" : Transaction.nextID(),
      "schedule": "Immediate (One Time)",
      "frequency" : "",
      "note" : "n/a"
    });

    transactionTransfer.mapID = transaction.id;
    // Create a new transaction and transfer and add to the global model
    BCMSRecord.batch([
      Transaction.create(transaction),
      TransferTransaction.create(transactionTransfer)
    ], context, Classes);
    // Close the modal and update the success state
    close("ReviewTransferModal");
    workflowStep.workflow.update({ ...workflowStep.defaultState, "success" : true });
  };

  return (
    <CustomModal title="Review Transfer" id="ReviewTransferModal" className="review-transfer-modal mobile-view-modal">
      <CustomModalContent>
        <p>A transfer of <b>{transferAmount}</b> will be made to <b>{transferToAccount}</b> from <b>{transferFromAccount}</b></p>
      </CustomModalContent>
      <CustomModalFooter>
        <div className="set-width">
          <ModalCloseButton text="Cancel" id="ReviewTransferModal" />
        </div>
        <div className="set-width">
          <ModalPrimaryButton text="Transfer" onClick={ submit } />
        </div>
      </CustomModalFooter>
    </CustomModal>
  );
}
